import React from 'react';
import './OrderSummaryDeferredNote.css';

/** Label for a line item whose amount is deferred until checkout (linked to footnote *). */
export function DeferredChargeLabel({ children }) {
  return (
    <span className="order-summary-defer-label">
      {children}
      <span className="order-summary-defer-mark" aria-hidden="true">
        *
      </span>
    </span>
  );
}

/** Pending amount placeholder (em dash), paired with {@link DeferredChargeLabel} * footnote. */
export function DeferredChargeValue() {
  return (
    <span className="order-summary-defer-value" title="Calculated at checkout">
      —
    </span>
  );
}

/** Footnote explaining deferred delivery charge and GST. */
export function OrderSummaryDeferredFootnote({ children }) {
  return (
    <p className="order-summary-defer-footnote" role="note">
      <span className="order-summary-defer-mark order-summary-defer-mark--lead" aria-hidden="true">
        *
      </span>
      <span>{children}</span>
    </p>
  );
}
